import React, { useEffect, useState } from 'react';
import SlidePanel from 'Components/SlidePanel/SlidePanel';
import useTranslation from '../../../Hooks/useTranslation';
import UnitList from './UnitList';
import UnitChannelList from './UnitChannelList';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

const ManageUnitChannelsModal = (props) => {

    const {
        isOpen,
        onCancel,
        onSave,
        editedModel,
        enableFilters,
        title,
        currentUnit,
        currentUnitModel,
        setCurrentUnit,
        unitsRequest,
        unitBoxes,
        section,
        newlyCreatedBoxType,
        onSaveEventLogger,
        licensesNames
    } = props;

    const translation = useTranslation();
    const [isSelectUnitStep, setIsSelectUnitStep] = useState(true);

    const { data: units, refetch } = unitsRequest;
    const [isUnitsLoading, setIsUnitsLoading] = useState(false);

    useEffect(() => {
        if (isOpen) {
            if (currentUnitModel) {
                setIsSelectUnitStep(false)
            }
        } else {
            setIsSelectUnitStep(true)
        }
    }, [isOpen, currentUnitModel])

    useEffect(() => {
        if (!isOpen || !isSelectUnitStep || currentUnitModel) {
            setIsUnitsLoading(false);
            return;
        }

        setIsUnitsLoading(true);
        refetch().finally(() => setIsUnitsLoading(false));
    }, [isOpen, isSelectUnitStep, currentUnitModel, refetch]);


    const handleBack = () => setIsSelectUnitStep(true);

    const handleSaveUnit = (unitId) => {
        setIsSelectUnitStep(false);
        setCurrentUnit(unitId);
    };

    const renderBackToUnitButton = () => {
        if (unitBoxes.length) return null;
        if (isSelectUnitStep) return null;

        return (
            <IconButton aria-label="back" size="small" onClick={handleBack}>
                <ArrowBackIcon fontSize="inherit" />
            </IconButton>
        );
    };

    const renderUnitList = () => {
        if (!isSelectUnitStep) return;

        return (
            <UnitList
                newlyCreatedBoxType={newlyCreatedBoxType}
                unit={currentUnitModel}
                items={units}
                onCancel={onCancel}
                onSave={handleSaveUnit}
                onSaveEventLogger={onSaveEventLogger}
                onSaveUnit={onSave}
                licensesNames={licensesNames}
                isLoading={isUnitsLoading}
            />
        );
    };

    const renderChannelsList = () => {
        if (isSelectUnitStep) return;

        return (
            <UnitChannelList
                enableFilters={enableFilters}
                editedModel={editedModel}
                unit={currentUnitModel}
                onCancel={() => {
                    setIsSelectUnitStep(true);
                    onCancel();
                }}
                onSave={onSave}
                unitsRequest={unitsRequest}
                section={section}
                isActive={isOpen && !isSelectUnitStep}
            />
        );
    };

    return (
        <SlidePanel
            open={isOpen}
            onClose={onCancel}
            title={isSelectUnitStep ? translation.headerUnitsLabel : title}
            headerStart={renderBackToUnitButton() ? <div className="backLinkHolder">{renderBackToUnitButton()}</div> : null}
            className={isSelectUnitStep ? 'appSlidePanel--wide' : ''}
        >
            {renderUnitList()}
            {renderChannelsList()}
        </SlidePanel>
    );
};

export default ManageUnitChannelsModal;
